module.exports = __webpack_public_path__ + "06_bob_grey.92ee1e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_bob_grey.png
// module id = 64Qs
// module chunks = 0